<template>
  <b-modal ref="modal" hide-footer no-close-on-backdrop hide-header-close>
    <template #modal-title>
      <span>
        {{ labels.title }}
      </span>
    </template>
    <div class="d-block pb-2">
      <div>
        <p class="text-primary">{{ labels.description }}:</p>
        <b-container fluid>
          <p class="h4 text-center pb-4">{{ linkAccountData.email }}</p>
          <p class="text-primary">
            {{ labels.beforemessage }}
            <span class="bold">{{ linkAccountData.serviceFrom }}</span>
            {{ labels.message }}
            <span class="bold">
              {{ linkAccountData.serviceTo }}
            </span>
            ?
          </p>
          <p class="text-primary">
            <span class="bold text-secondary">
              {{ labels.reminderBeforeMessage }}:
            </span>
            {{ labels.reminderMessage }}
          </p>
        </b-container>
      </div>
    </div>
    <div class="footer pt-4">
      <b-button
        variant="secondary"
        class="float-right modal-btn"
        :title="labels.submit"
        @click="doLink"
      >
        {{ labels.submit }}
      </b-button>
      <b-button
        variant="link"
        class="float-right text-transform-none modal-btn"
        :title="labels.cancelButton"
        size="lg"
        @click="hide()"
      >
        {{ labels.cancelButton }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  linkAccount: {
    type: Object,
  },
}

export default {
  props,
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return {
        cancelButton: this.resources.general.buttons.cancel,
        ...this.resources.page.login.auth.linkAccount,
      }
    },
    linkAccountData() {
      return this.linkAccount ? this.linkAccount : {}
    },
  },
  methods: {
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    doLink() {
      this.$emit('doLink')
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.modal-btn {
  border-radius: 10px !important;
  min-width: 160px;
}
</style>
